module.exports = __webpack_public_path__ + "static/media/rounded2button.9dc76e8e.svg";